// Add the sticky class to the navbar when you reach its scroll position. Remove the sticky class when you leave the scroll position.
function myFunction() {
  // Get the navbar
  const floatBuyButton = document.getElementsByClassName("float-buy-button")[0];
  const wrapButtonBuy = document.getElementsByClassName("wrap-button-buy")[0];
  const footer = document.getElementsByClassName("footer-bottom")[0];
  const footerOffset =
    footer.getBoundingClientRect().top + document.documentElement.scrollTop;
  const windowHeight = window.innerHeight;
  if (document.documentElement.scrollTop <= 50) {
    floatBuyButton.classList.remove("show");
  } else if (
    document.documentElement.scrollTop > 50 &&
    document.documentElement.scrollTop + windowHeight <= footerOffset
  ) {
    floatBuyButton.classList.add("show");
    wrapButtonBuy.classList.remove("hide");
  } else {
    floatBuyButton.classList.remove("show");
    wrapButtonBuy.classList.add("hide");
  }
}
document.addEventListener(
  "scroll",
  utils.throttle(myFunction, 100, {
    leading: false,
    trailing: true,
  })
);

